import { CommonModule } from '@angular/common';
import { Component, input, InputSignal, OnInit } from '@angular/core';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class ProgressBarComponent implements OnInit {
  loaderHeight: InputSignal<string> = input("32px");
  loaderWidth: InputSignal<string> = input("32px");
  borderColor: InputSignal<string> = input("#D1D5DB");
  borderWidth: InputSignal<string> = input("2px");
  ngOnInit(): void {
  }
}
